var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yy-empty"},[_c('img',{attrs:{"src":_vm.typeList[_vm.type].src}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text||_vm.typeList[_vm.type].text))])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/empty/empty.vue?vue&type=template&id=031deb74&
// module id = 115
// module chunks = 0